import DriveService from "./DriveService";

export default class PublicAccessService {
  private driveService: DriveService;
  private type: string;
  private paramEncrypted: string;
  private isPublic: boolean;
  private extraParams: any;

  constructor(driveService: DriveService, type = '', paramEncrypted = '', extraParams = {}) {
    this.driveService = driveService;
    this.type = type;
    this.paramEncrypted = paramEncrypted;
    this.isPublic = !!type && !!paramEncrypted;
  }

  async getResources(path = '', resourceId = '', parentId = '', onlyDir = false) {
    if (!this.isPublic) return [];

    this.extraParams = {
      path: path ?? '',
      resource_id: resourceId ?? '',
      parent_id: parentId ?? '',
      only_dir: onlyDir ?? false
    };

    try {
      const response = await this.driveService.getResourceByPublicLink(this.type, this.paramEncrypted, this.extraParams);
      //console.log('Drive Access Service getResources:', response);
      return response;
    } catch (error) {
      console.error('Erro ao carregar recursos públicos:', error);
      throw error;
    }
  }

  // Métodos adicionais específicos para acesso público
  getIsPublic() {
    return this.isPublic;
  }

  getPublicParams() {
    return {
      type: this.type,
      paramEncrypted: this.paramEncrypted
    };
  }

}